import api from "./api"
import { getStoredShipper } from "../constants/utils"

const CHARGE_MANAGEMENT_ROOT = "api"

const chargeManagementApi = {
    getDemurrageSummaries() {
        const { STORED_SHIPPER_NAME, STORED_RAILROAD_NAME } = getStoredShipper()

        return api.post(
            `${CHARGE_MANAGEMENT_ROOT}/GetDemurrageRevenueSummaries`,
            {
                ApiStandardParameters: {
                    Road: STORED_RAILROAD_NAME,
                    Shipper: STORED_SHIPPER_NAME,
                },
            },
            "STAGING"
        )
    },
    getDemurrageDetails(summaryData) {
        const { STORED_SHIPPER_NAME, STORED_RAILROAD_NAME } = getStoredShipper()

        return api.post(
            `${CHARGE_MANAGEMENT_ROOT}/GetDemurrageDetails`,
            {
                ApiStandardParameters: {
                    Road: STORED_RAILROAD_NAME,
                    Shipper: STORED_SHIPPER_NAME,
                },
                Filter: {
                    CustomerId: summaryData.CustomerId,
                    HoldType: summaryData.HoldType,
                    InvoiceNumber: summaryData.InvoiceNumber,
                    CalculationType: summaryData.CalculationType,
                    CurrencyCode: summaryData.CurrencyCode,
                },
            },
            "STAGING"
        )
    },
}

export default chargeManagementApi
